import ConfigurePlan from './ConfigurePlan';

export default ConfigurePlan;
